import { Component, computed, input, OnInit, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { Action, ActionMode, View } from '../../store/view/types';
import { ViewService } from '../../store/view/views.service';
import { SubHeaderService } from '../../store/subheader/subheader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { buildActionRouterLink, isVisibleWhen } from '../../helper/viewhelper';
import { debugLog } from '../../pipe/rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-actions-group',
  standalone: false,
  templateUrl: './actions-group.component.html',
  styleUrl: './actions-group.component.scss',
})
export class ActionsGroupComponent implements OnInit {
  view$: Observable<View>;
  private readonly actions = signal<Action[]>([]);

  readonly actionsGroupName = input<string>('');
  readonly model = input<any>(null);

  /**
   * Visibility and routerLink are resolved here, once per change of the view or of the model,
   * rather than in the template: a method binding runs on every change detection cycle, and the
   * new array it returns makes RouterLink recompute its UrlTree each time.
   */
  protected readonly buttons = computed(() =>
    this.actions().map((action) => ({
      action,
      visible: isVisibleWhen(this.model(), action.visibleWhen),
      routerLink: buildActionRouterLink(action, this.model()),
    })),
  );

  protected readonly ActionMode = ActionMode;

  constructor(
    private readonly viewService: ViewService,
    private readonly subHeaderService: SubHeaderService,
  ) {
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.view$
      .pipe(
        untilDestroyed(this),
        // debugLog('veiu'),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        if (x.actions) {
          const index = x.actions.findIndex(
            (y) => y.name === this.actionsGroupName(),
          );
          this.actions.set(
            index >= 0 ? x.actions[index]?.listOfActions ?? [] : [],
          );
        }
        // console.log(this.actions);
      });
  }

  triggerAction(actionName) {
    this.subHeaderService.setTriggerAction(actionName);
  }
}
